import { Phone, CheckCircle2, ShoppingBag, CreditCard, MessageSquare } from "lucide-react";
import useScrollReveal from "@/hooks/useScrollReveal";

const ErlebniskochenSection = () => {
  const sectionRef = useScrollReveal();

  return (
    <section id="erlebniskochen" data-testid="erlebniskochen-section" className="section-padding bg-white" ref={sectionRef}>
      <div className="container-custom">
        <div className="text-center max-w-2xl mx-auto mb-16 reveal">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-4">Leistungen</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight mb-4 font-[Outfit]">
            Thermomix® Erlebniskochen in Krefeld – kostenlos testen
          </h2>
          <p className="text-slate-600 text-lg leading-relaxed">
            Erlebe den TM7 bei dir zuhause. Ein klassisches Erlebniskochen dauert ca. 2 Stunden und besteht aus 5 Gängen – Eis, Brot, Salat, Dip und Hauptspeise. Du lädst 3 weitere Haushalte ein, ich bringe das Gerät und den Großteil der Zutaten mit.
          </p>
        </div>
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
          {/* Left - Card */}
          <div className="relative reveal">
            <div className="absolute -inset-4 bg-stone-100 rounded-[2rem] rotate-2" />
            <div className="relative glass-card rounded-[2rem] shadow-2xl overflow-hidden">
              <div className="aspect-video relative">
                <img
                  src="https://customer-assets.emergentagent.com/job_thermomix-zuhause/artifacts/6145ht4f_1bfbb0f1-ab00-45be-9053-392db48d3757.jpeg"
                  alt="Jennifer Laak Thermomix TM7 Erlebniskochen Krefeld - Kostenlos testen"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-8">
                  <p className="text-white font-bold text-2xl italic font-[Outfit]">Kocherlebnis wie nie zuvor</p>
                </div>
              </div>
              <div className="p-8 md:p-10">
                <h3 className="text-2xl md:text-3xl font-bold mb-6 font-[Outfit]">Kostenlos testen in Krefeld</h3>
                <div className="space-y-4 mb-8">
                  {["5-Gänge-Menü gemeinsam gekocht", "Ca. 2 Stunden Dauer", "Ab 3 Haushalten – Wunschrezept zu zweit auch möglich", "Kostenlos & unverbindlich"].map((t, i) => (
                    <div key={i} className="flex items-center gap-3 font-semibold text-slate-700">
                      <CheckCircle2 className="text-emerald-600 w-5 h-5 flex-shrink-0" /> {t}
                    </div>
                  ))}
                </div>
                <a href="tel:01721697433" data-testid="erlebniskochen-cta" className="w-full btn-primary px-8 py-5 text-lg">
                  <Phone className="w-5 h-5" /> Jetzt Termin anfragen
                </a>
              </div>
            </div>
          </div>

          {/* Right - Benefits */}
          <div className="mt-16 lg:mt-0 reveal reveal-delay-1">
            <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-4 italic">Dein Mehrwert</span>
            <h3 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-10 leading-tight font-[Outfit]">Vorteile, die schmecken</h3>
            <div className="space-y-10">
              <div className="flex gap-6">
                <div className="flex-shrink-0 w-14 h-14 bg-slate-900 text-white rounded-2xl flex items-center justify-center shadow-lg"><ShoppingBag className="w-6 h-6" /></div>
                <div>
                  <h4 className="text-xl font-bold mb-2 font-[Outfit]">Persönliche Bestellung & Lieferung</h4>
                  <p className="text-slate-500 text-sm leading-relaxed">Ich unterstütze dich bei der Bestellung und feiere mit dir das Eintreffen deines neuen Helfers direkt bei dir vor Ort.</p>
                </div>
              </div>
              <div className="flex gap-6">
                <div className="flex-shrink-0 w-14 h-14 bg-slate-900 text-white rounded-2xl flex items-center justify-center shadow-lg"><CreditCard className="w-6 h-6" /></div>
                <div>
                  <h4 className="text-xl font-bold mb-2 font-[Outfit]">Finanzierungs-Beratung</h4>
                  <p className="text-slate-500 text-sm leading-relaxed">Gemeinsam finden wir die beste Zahlungsoption. Ob Sofortkauf oder bequeme 0% Rate – ich habe alle Aktionen im Blick.</p>
                </div>
              </div>
              <div className="flex gap-6">
                <div className="flex-shrink-0 w-14 h-14 bg-slate-900 text-white rounded-2xl flex items-center justify-center shadow-lg"><MessageSquare className="w-6 h-6" /></div>
                <div>
                  <h4 className="text-xl font-bold mb-2 font-[Outfit]">Exklusiver Kunden-Support</h4>
                  <p className="text-slate-500 text-sm leading-relaxed">Du hast Fragen zu einem Rezept? Ein Anruf genügt. Ich bin deine persönliche Expertin direkt in der Nachbarschaft.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ErlebniskochenSection;
